import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApicallService } from '../services/apicall.service';
import { PermissionService } from "../services/permission.service";

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard  {

  constructor(public apiCallService: ApicallService, private router: Router, public permissionService: PermissionService) { }

     canActivate(): boolean {
        if(this.apiCallService.loggedIn() && this.apiCallService.user == undefined){
          this.apiCallService.loadUser();
          this.apiCallService.loadPath();
          this.apiCallService.loadToken();
        }
        if (this.apiCallService.loggedIn()) {
            if(this.apiCallService.user.roles[0].type === 'child-agent'){
              this.router.navigate(['/org-mapped']);
            }else{
              this.router.navigate(['/dashboard']);
            }
            return false;
        } else {
          return true
        }
    }
  
}
